import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { DynamicFormElementDto, NotificationBulkLogDto, BulkNotificationDto, NotificationBulkDto, ResultListDto, CommunicationPlaceholders } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpCommunicationService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/communication', authService);
	}
	public getFilters(): Observable<DynamicFormElementDto[]> {
		return super.doGet(true, "/filters");
	}

	public getFilterCount(payload: BulkNotificationDto): Observable<number> {
		return super.doPost(true, "/filter-count", payload);
	}

	public add(payload: BulkNotificationDto): Observable<void> {
		return super.doPost(true, "/add", payload);
	}
	public edit(payload: BulkNotificationDto): Observable<void> {
		return super.doPost(true, "/edit", payload);
	}

	public getScheduledAutomated(pageIndex?: number, pageSize?: number): Observable<ResultListDto<BulkNotificationDto>> {
		return super.doGet(true, `/get-scheduled-automated?&pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`);
	}

	public get(bulkId: number): Observable<BulkNotificationDto> {
		return super.doGet(true, `/get/${bulkId}`);
	}

	public getLog(pageIndex?: number, pageSize?: number): Observable<ResultListDto<NotificationBulkLogDto>> {
		return super.doGet(true, `/get-log?&pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`);
	}

	public changeStatus(bulk: NotificationBulkDto): Observable<void> {
		return super.doPost(true, "/change-status", bulk);
	}

	public getPlaceholders(): Observable<CommunicationPlaceholders> {
		return super.doGet(true, `/placeholders`);
	}
}
